import { IDefineCommand, ICommand } from 'core-ts-types';
import * as _4 from 'lodash4';
import { ISectionsDatasource } from '../../views/sections/datasources/sections_datasource';
import { ScheduledSectionStatus } from '../../views/course_scheduler/types/scheduled_section_status_enum';
import { MultiSectionServant } from '../../views/course_scheduler/servants/multi_section_servant';
import { ISectionSwapToFrom, ISectionSwapModel } from '../models/course_section_swap_model';
import { ISection } from '../../interfaces/scheduler_interfaces';
import { IModel } from 'utility-ts-orm';
import { TermCourseServant } from '../../views/term_courses/servants/term_course_servant';

angular
  .module('capability-ng-scheduler')
  .service(
    'updateSwapFromSectionTypeCommand',
    function updateSwapFromSectionTypeCommandDefinition(
      $http: ng.IHttpService,
      defineCommandORM: IDefineCommand,
      ngCourseSectionSwapModel: IModel<ISectionSwapModel>,
      ngSectionsDatasource: ISectionsDatasource,
      ngMultiSectionServant: MultiSectionServant,
      log: any,
      updateSwapSectionStatusCommand: ICommand,
      ngTermCourseServant: TermCourseServant
    ) {
      'use strict';

      return defineCommandORM(
        'updateSwapFromSectionTypeCommand',
        function updateSwapFromSectionTypeCommand(deferred, sectionType) {
          const previousFromSection = ngCourseSectionSwapModel.read().from_section;
          let updatedFromSection: ISectionSwapToFrom;

          updatedFromSection = {
            id: previousFromSection.id,
            section_type: sectionType.id
          };

          ngCourseSectionSwapModel.write({
            from_section: updatedFromSection
          });

          deferred.resolve(ngCourseSectionSwapModel.read());
        }
      );
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/swap/commands/update_swap_from_section_type_command.ts